// Las dos decisiones del aviso de nueva versión, sin navegador — PA-3.
// SPEC_AVISO_NUEVA_VERSION_v0.1.md — RN-173, RN-176
//
// Viven aparte para probarlas con la suite pura. El resto del mecanismo
// (`services/appVersionService.js`) es pegamento con `fetch` y eventos del DOM.

// RN-173: sólo hay versión nueva si el servidor dice un build distinto del de
// esta pestaña. Una respuesta sin `build` —un `index.html` servido por error,
// un JSON vacío— no es una versión: no avisa.
export function hayVersionNueva (actual, remota) {
  const build = remota && typeof remota === 'object' ? remota.build : null
  return typeof build === 'string' && build.length > 0 && build !== actual
}

// RN-176: el error que da webpack cuando un chunk de un despliegue anterior ya
// no existe en el servidor.
export function esErrorDeChunk (error) {
  return error?.name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || '')
}
